<template>
    <div class="basic">
        <Form ref="formInline" :model="formInline" style="width: 100%" :rules="ruleInline" label-position="top"
            @on-validate="getvalidate">
            <div class="basic-header">
                <p>企业基本信息</p>
            </div>
            <div style="border:solid 1px #e5e5e5;margin-bottom: 30px;padding-top:20px">
                <!-- 公司名称 -->
                <div class="basic-name">
                    <Row :gutter="10">
                        <Col span="12">
                        <div style="display: flex">
                            <FormItem label="企业名称" prop="companyName">
                                <Input type="text" v-model="formInline.companyName"
                                    style="width: 270px; margin-right: 10px" placeholder="请输入企业名称全称" />
                            </FormItem>
                            <FormItem label="简称" prop="companyNameShort">
                                <Input type="text" placeholder="请输入公司简称（2~4个字）" v-model="formInline.companyNameShort"
                                    style="width: 270px; margin-right: 10px" />
                            </FormItem>
                        </div>
                        </Col>
                        <Col span="12">
                        <div style="display: flex">
                            <FormItem label="英文名称" prop="">
                                <Input type="text" placeholder="请输入英文名称" v-model="formInline.companyNameEn"
                                    style="width: 270px; margin-right: 10px" />
                            </FormItem>
                        </div>
                        </Col>
                    </Row>
                </div>

                <!-- 公司地址 -->
                <div class="basic-name">
                    <Row :gutter="10">
                        <Col span="12">
                        <FormItem label="企业地址">
                            <!-- <FormItem label="企业地址" required prop="addresss"> -->
                            <div style="width:550px">
                                <mFormAddress v-model="formInline.addresss" @change="validAddresss"></mFormAddress>
                            </div>
                        </FormItem>
                        </Col>

                        <Col span="12">
                        <div style="padding: 0 0 3px 0;"></div>
                        <div style="display: flex">
                            <!-- <FormItem prop="address" id="address" label="详细地址"> -->
                            <FormItem id="address" label="详细地址">
                                <Input type="text" placeholder="请输入详细地址" v-model="formInline.address"
                                    style="width: 410px; margin-right: 10px" />
                            </FormItem>
                        </div>
                        </Col>
                    </Row>
                </div>
            </div>

            <!-- 展会联系人 -->
            <div class="basic-link">
                <FormItem label="展会联系人" required> </FormItem>
            </div>
            <div style="border:solid 1px #e5e5e5;margin-bottom: 30px">
                <div class="basic-links">
                    <Row :gutter="10">
                        <Col span="12">
                        <div style="display: flex">
                            <FormItem label="姓名" prop="linkMan">
                                <Input type="text" placeholder="展会联系人真实姓名" v-model="formInline.linkMan"
                                    style="width: 270px; margin-right: 10px" />
                            </FormItem>
                            <FormItem label="职务" prop="linkTitle">
                                <Input type="text" placeholder="展会联系人职务" v-model="formInline.linkTitle"
                                    style="width: 270px" />
                            </FormItem>
                        </div>
                        </Col>
                        <Col span="12">
                        <div style="display: flex">
                            <FormItem label="手机" prop="linkMob">
                                <Input type="text" placeholder="展会联系人手机号" v-model="formInline.linkMob"
                                    style="width: 270px; margin-right: 10px" />
                            </FormItem>
                            <FormItem label="邮箱" prop="linkEmail">
                                <Input type="text" placeholder="展会联系人邮箱" v-model="formInline.linkEmail"
                                    style="width: 270px" />
                            </FormItem>
                        </div>
                        </Col>
                    </Row>
                </div>
            </div>

            <!-- 参展产品 -->
            <div class="basic-link">
                <FormItem label="参展产品" required> </FormItem>
            </div>
            <div style="border:solid 1px #e5e5e5;margin-bottom: 30px">
                <div class="basic-links">
                    <Row :gutter="10">
                        <Col span="12">
                        <div style="display: flex">
                            <FormItem label="所属行业" prop="industry">
                                <Select v-model="formInline.industry" style="width:270px;margin-right: 10px"
                                    placeholder="请选择所属行业">
                                    <Option v-for="item in cityList" :value="item.hyxz" :key="item.id">{{
                                        item.hyxz
                                        }}</Option>
                                </Select>
                            </FormItem>
                            <FormItem label="重点展示产品" prop="highlightProducts">
                                <Input type="text" placeholder="产品名称" v-model="formInline.highlightProducts"
                                    style="width: 270px" />
                            </FormItem>
                        </div>
                        </Col>
                    </Row>
                </div>
            </div>

            <!-- 展位预定信息 -->
            <div class="basic-header" style="margin-bottom: 30px">
                <p><span style="color: red;background-color: #1e88e5;    margin: 0 0px;">*</span> 展位预定信息 <span
                        style="color: red;" class="bgNone">（合作类型和展区任选其一即可）</span></p>
            </div>

            <!-- 赞助类型 -->
            <div class="basic-link " style="padding: 0 0  0 30px;" :class="[single == '已选择1' ? headCssData : '']">
                <FormItem label="">
                    <div style="display: flex; justify-content: space-between;" @click="sponsorSelect1()">
                        <p style="font-size: 18px;line-height: 48px;">合作类型</p>
                        <p class="selectedStyle">
                            <RadioGroup v-model="single">
                                <Radio v-if="single == '已选择1'" label="已选择1">已选择</Radio>
                            </RadioGroup>
                        </p>
                    </div>
                </FormItem>
            </div>
            <div style="margin-bottom: 30px" :class="[single == '已选择1' ? footCssData : 'borderCss']"
                @click="sponsorSelect1()">
                <div style="padding: 30px 0 10px 30px;padding-top: 10px;">
                    <div class="tabs">
                        <div class="tabs-top">
                            <Row :gutter="24">
                                <Col span="4" v-for="(item, index) in listPavilion" :key="index"
                                    style="margin-top: 20px;">
                                <!-- <div class="tag" :class="{ active: areaIndex === index }"
                            @click="areaName = item.tname; areaIndex = index;getOrder(item)">
                            <span>{{ item.tname }}</span>
                        </div> -->
                                <Tooltip :content="item.text" placement="bottom" theme="light" style="max-width:1200px">
                                    <!-- <span 
                                    :style="{background:item.tname == '首席'? '#c5c8c1' : '',}"
                                     style="width: 160px; display: block; border-radius: 4px; height: 32px;text-align: center; height: 32px;padding: 0 15px; line-height: 32px;" 
                                        class="borderCss"
                                        :class="{'borderCssButt':sponsorValIndex.indexOf(index)>-1}" 
                                        @click="sponsorChange(item, index)">{{
                                            item.tname
                                        }}</span> -->
                                    <Button :disabled="item.tname == '首席'" style="width: 140px;"
                                        :class="[sponsorValIndex == index ? 'borderCssButt' : '']"
                                        @click="sponsorChange(item, index)">{{
                                            item.tname
                                        }}</Button>
                                    <div slot="content">
                                        <p v-if="item.text0">{{ item.text0 }}</p>
                                        <p v-if="item.text1">{{ item.text1 }}</p>
                                        <p v-if="item.text2">{{ item.text2 }}</p>
                                        <p v-if="item.text3">{{ item.text3 }}</p>
                                        <span v-if="item.text6">{{ item.text6 }}</span>
                                        <span v-if="item.text4" style="color: #337FE5;">{{ item.text4 }}</span>
                                        <span v-if="item.text5">{{ item.text5 }}</span>
                                    </div>
                                </Tooltip>
                                </Col>
                                <!-- <p style="margin-top: 80px;font-size: 12px;color: #7f7f7f">（置灰选项为售罄，不可选择）</p> -->
                            </Row>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 选择展区 -->
            <div class="basic-link" style="padding: 0 0  0 30px;" :class="[single == '已选择2' ? headCssData : '']">
                <FormItem label="">
                    <div style="display: flex; justify-content: space-between;" @click="sponsorSelect2()">
                        <p style="font-size: 18px;line-height: 48px;">选择展区</p>
                        <p class="selectedStyle">
                            <RadioGroup v-model="single">
                                <Radio v-if="single == '已选择2'" label="已选择2">已选择</Radio>
                            </RadioGroup>
                        </p>
                    </div>
                </FormItem>
            </div>
            <div style="margin-bottom: 30px" :class="[single == '已选择2' ? footCssData : 'borderCss']"
                @click="sponsorSelect2()">
                <div style="padding: 30px 0 10px 30px;padding-top: 30px;">
                    <Row :gutter="10">
                        <Col span="12">
                        <div style="display: flex">
                            <FormItem label="选择展区" prop="">
                                <!-- <Input type="text" placeholder="选择展区" v-model="formInline.linkMan"
                  style="width: 270px; margin-right: 10px" /> -->
                                <Select v-model="exVal" style="width:270px;margin-right: 10px" placeholder="请选择展区"
                                    @on-change="exValSelect">
                                    <Option v-for="item in exAreaListVipFalse" :value="item.id" :key="item.id">{{
                                        item.name
                                        }}</Option>
                                </Select>
                                <p style="font-size: 12px;color:#808080">请根据您所填公司所属行业选择对应展区</p>

                            </FormItem>
                            <FormItem label="" prop="" style="margin-left: 80px;display: flex;align-items: center;">
                                <div style="display: flex;color:#333333 ">
                                    <div>
                                        <RadioGroup v-model="animal" style="width: 500px;"
                                            @on-change="exValSelect(exVal)">
                                            <Radio label="光地" :disabled="sponsorDis">光地：2200/㎡（18㎡起）</Radio>
                                            <Radio label="标展" :disabled="sponsorDis">标展：2400/㎡ （12㎡起）</Radio>
                                        </RadioGroup>
                                    </div>
                                    <div style="display: flex;align-items: center;width: 200px;">
                                        预定面积<InputNumber :max="99999999999" :min="1" v-model="value1"
                                            @on-change="areaInputChange" :disabled="sponsorDis"
                                            style="margin-left: 8px;" placeholder="请输入">
                                        </InputNumber> ㎡
                                    </div>
                                </div>
                            </FormItem>
                        </div>
                        </Col>
                    </Row>
                </div>
            </div>

            <!-- 附件上传 -->
            <!-- <div class="basic-header">
                <p> 附件上传</p>
            </div>
            <div style="border:solid 1px #e5e5e5;margin-bottom: 30px">
                <div class="basic-links">
                    <Row :gutter="10">
                        <Col span="12">
                        <FormItem label="营业执照上传（小于2M）" required>
                            <div style="display: flex; position: relative">
                                <Upload ref="upload" :show-upload-list="false" :default-file-list="defaultList"
                                    :on-success="handleSuccess" :format="['jpg', 'png']" :max-size="2048"
                                    :headers="formHeaders" :on-format-error="handleFormatError"
                                    :on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload"
                                    :action="uploadUrl" style="margin-right: 10px">
                                    <div class="upload-btn">上传营业执照</div>
                                </Upload>
                                <p style="position: absolute;left: 0;top: 34px;font-size: 12px;color: #808080;">
                                    仅支持jpg,png，不超过2M
                                </p>
                                <div class="license-img">
                                    <template v-if="uploadList && uploadList.length">
                                        <div class="license-img-list" v-for="(item, index) in uploadList"
                                            :key="'upload' + index">
                                            <template v-if="item.status === 'finished'">
                                                <span class="txt1" :title="item.name" v-if="item.name">{{
                                                    item.name.split('.')[0]
                                                }}</span>
                                                <span class="line"></span>
                                                <span @click="handleRemoveByArr(item)">删除</span>
                                            </template>
</div>
</template>
</div>
</div>
</FormItem>
</Col>
<Col span="12">
<FormItem label="公司logo" required>
    <div style="display: flex; position: relative">
        <Upload ref="upload" :show-upload-list="false" :default-file-list="defaultList2" :on-success="handleSuccess2"
            :format="['jpg', 'png']" :max-size="2048" :headers="formHeaders" :on-format-error="handleFormatError2"
            :on-exceeded-size="handleMaxSize2" :before-upload="handleBeforeUpload2" :action="uploadUrl"
            style="margin-right: 10px">
            <div class="upload-btn">上传公司logo</div>
        </Upload>
        <p style="
                    position: absolute;
                    left: 0;
                    top: 34px;
                    font-size: 12px;
                    color: #808080;
                  ">
            仅支持jpg,png，不超过2M
        </p>
        <div class="license-img">
            <template v-if="uploadList2 && uploadList2.length">
                                        <div class="license-img-list" v-for="(item, index) in uploadList2"
                                            :key="'upload' + index">
                                            <template v-if="item.status === 'finished'">
                                                <span class="txt1" :title="item.name" v-if="item.name">{{
                                                    item.name.split('.')[0]
                                                }}</span>
                                                <span class="line"></span>
                                                <span @click="handleRemoveByArr2(item)">删除</span>
                                            </template>
        </div>
        </template>
    </div>
    </div>
</FormItem>
</Col>
</Row>

</div>
</div> -->

            <!-- <div class="handle-box">
        <Button :loading="loading" @click="handleSubmit('formInline')" class="handle-box-btn" type="primary">保存并提交</Button>
      </div> -->

            <!-- <div class="basic-link" style="padding: 0 0  15px 30px;">
                <FormItem label="">
                    <div style="">
                        <p style="font-size: 18px;line-height: 48px;font-weight: 700;">中国新建医院科技创新大会暨国际新建医院高科技创新解决方案博览会</p>
                        <p style="font-size: 14px;line-height: 25px;">
                            &ensp;&ensp;
                            由筑医台、国药励展、筑而端联合多家权构共同举办的“中国新建医院科技创新大会暨国际新建医院高科技创新解决方案博览会”与CMEF第88届中国国际医疗器械（秋季)博览会将于2023年10月28-30日在深圳国际会展中心(宝安区) 同期举办，本届大会汇聚国内外医院建设领域顶级解决方案，引领医院建设科技创新最高水平，为产学研用各方呈现一场科技新高度、新体验的视觉盛宴。
                        </p>
                    </div>
                </FormItem>
            </div> -->


        </Form>
    </div>
</template>

<script>
import mFormAddress from "@/components/m-form/m-form-address.vue";
import { mapGetters, mapActions } from "vuex";
import { validator } from "@/other/validator";
import { join } from "path";
export default {
    name: "register-form", // 参展申请 - 基本信息
    components: {
        mFormAddress,
    },
    data() {
        const that = this;
        const zhValid = (rule, value, callback) => {
            if (/^[\u4e00-\u9fa5]+$/.test(value)) {
                callback();
            } else {
                callback(new Error('公司名称格式有误'));
            }
        };
        // 判断英文
        const enValid = (rule, value, callback) => {
            if (!value) {
                callback();
            } else {
                if (/^([a-zA-Z]+\s)*[a-zA-Z]+$/.test(value)) {
                    callback();
                } else {
                    callback(new Error('英文名称格式有误'));
                }
            }
        };
        const companyAddressValid = (rule, value, callback) => {
            if (that.formInline.addresss.country && that.formInline.addresss.country === '中国') { // 中国 判断省份和城市是否选择
                if (!that.formInline.addresss.province) {
                    callback(new Error('省份为空'));
                } else if (!that.formInline.addresss.city) {
                    callback(new Error('城市为空'));
                } else if (!that.formInline.addresss.county) {
                    callback(new Error('区县为空'));
                }
                else {
                    callback();
                }
            } else {
                if (that.formInline.addresss.country) {
                    callback();
                } else {
                    callback(new Error('地址为空'));
                }
            }
        };



        return {
            listPavilion: [
                { tname: "首席", text0: '', text1: '合作价格：190万起', text2: '展位面积：180平米起', text3: '其他权益：广告、列名、媒体、演讲及其他独家服务（具体权益内容请拨打010-68629938咨询）' },
                { tname: "VVIP", text0: '合作数量：限10家', text1: '合作价格：65万起', text2: '展位面积：252平米起', text3: '其他权益：VIP展位、广告、列名、媒体、演讲及其他服务等' },
                { tname: "战略合作", text0: '合作数量：限3家', text1: '合作价格：150万起', text2: '展位面积：180平米起', text3: '其他权益：VIP展位、广告、列名、媒体、演讲及其他服务等' },
                { tname: "深度支持", text0: '合作数量：限3家', text1: '合作价格：110万起', text2: '展位面积：150平米起', text3: '其他权益：VIP展位、广告、列名、媒体、演讲及其他独家服务' },
                { tname: "支持单位", text0: '合作数量：限15家', text1: '合作价格：68万起', text2: '展位面积：150平米起', text3: '其他权益：VIP展位、广告、列名、媒体、演讲及其他独家服务' },
                { tname: "荣誉赞助A", text0: '合作数量：限20家', text1: '合作价格：35万起', text2: '展位面积：120平米起', text6: '其他权益：VIP展位、广告、列名、媒体、', text4: '演讲', text5: '及其他服务等' },
                { tname: "荣誉赞助B", text0: '合作数量：限20家', text1: '合作价格：35万起', text2: '展位面积：120平米起', text6: '其他权益：VIP展位、', text4: '精品广告', text5: '、列名、媒体及其他服务等' },
                { tname: "荣誉赞助C", text0: '合作数量：限20家', text1: '合作价格：24万起', text2: '展位面积：60平米起', text3: '其他权益：其他权益：VIP展位、广告、列名、媒体、演讲及其他服务等' },
                { tname: "荣誉赞助D", text0: '合作数量：限20家', text1: '合作价格：24万起', text2: '展位面积：60平米起', text3: '其他权益：VIP展位、精品广告、列名、媒体及其他服务等' },
                // { tname: "光地展位", text0: '2100 元人民币 / ㎡ ，18 ㎡起售，仅为一块空地 ' },
                // { tname: "标准展位", text0: '2300 元人民币 / ㎡，12 ㎡起售，包含基本家具、地毯、照明、插座、楣板' },
                { tname: "CHCC医院建设奖", text0: 'CHCC医院建设奖战略合作单位' },
                { tname: "专场论坛合作", text0: '企业专场论坛（协办）/论坛支持单位' },

                { tname: "演讲", text0: '演讲' },
                { tname: "媒体合作", text0: '媒体合作' },
                { tname: "广告合作", text0: '广告合作' },

            ],


            loading: false,
            isInvoice: false,
            formInline: {
                // 企业基本信息
                companyName: "", // 公司名称
                companyNameShort: "", // 公司简称
                companyNameEn: "",// 公司英文名称
                address: "", // 详细地址
                addresss: {
                    country: "中国", // 国家
                    province: "", // 省份
                    city: "", // 城市
                    county: "", // 区县 
                },

                // 展会联系人
                linkMan: "",
                linkTitle: "",
                linkMob: "", // 手机
                linkEmail: "",

                // 所属行业
                industry: '',
                highlightProducts: "",

            },
            formInline1: {
                // 企业基本信息
                companyName: "上海连战技术有限公司", // 公司名称
                companyNameShort: "连战", // 公司简称
                companyNameEn: "lianzhan",// 公司英文名称
                address: "", // 详细地址
                addresss: {
                    country: "中国", // 国家
                    province: "", // 省份
                    city: "", // 城市
                    county: "", // 区县 
                },
                // 展会联系人
                linkMan: "某某",
                linkTitle: "技术",
                linkMob: "17630757850",
                linkEmail: "",
                // 所属行业
                industry: '建筑与装饰材料类',
                highlightProducts: "产品",
            },
            ruleInline: {
                // 企业基本信息
                companyName: [
                    { required: true, message: "请输入企业名称全称", trigger: "blur" },
                    // { validator: zhValid, trigger: "blur" }
                ],
                companyNameShort: [
                    { required: true, message: '请输入公司简称（2~4个字）', trigger: 'blur' }
                ],
                companyNameEn: [
                    { validator: enValid, trigger: "blur" }
                ],
                creditCode: [
                    {
                        required: true,
                        message: "统一社会信用代码不能为空",
                        trigger: "blur",
                    },
                    ...validator.CreditCode,
                ],
                addresss: [{
                    required: true,
                    validator: companyAddressValid, trigger: "blur"
                }],
                address: [
                    { required: true, message: "请输入详细地址", trigger: "blur" },
                ],

                // 展会联系人
                linkMan: [{ required: true, message: "请输入姓名", trigger: "blur" }],
                linkTitle: [{ required: true, message: "请输入职务", trigger: "blur" }],
                linkMob: [
                    {
                        required: true,
                        message: "请输入手机号",
                        trigger: "blur",
                    },
                    ...validator.phone
                ],
                linkEmail: [{ type: 'email', message: '邮箱格式有误', trigger: 'change' }],


                // 所属行业
                industry: [{ required: true, message: "请选择所属行业", trigger: "change" }],

                highlightProducts: [{ required: true, message: "请填写产品名称", trigger: "blur" }],

            },
            defaultList: [],
            uploadList: [],
            uploadName: "",
            defaultList2: [],
            uploadList2: [],
            uploadName2: "",

            isExport: true, // 是否是外销企业
            isListed: true, // 是否是上市公司
            isTop500: true, // 是否是世界五百强
            isMicroEnterprise: true, // 是否为小微企业
            isHighTech: true, // 是否为高新技术企业  

            basicInfo: null,
            validateList: [],
            ElepropName: "", //验证错误的prop名
            companyId: "", //公司ID
            isOption: true, //企业经营类型是否是选择框 

            countryList: [],
            provinceArr: [],
            citiesArr: [],
            single: '',
            headCssData: 'headCss',
            footCssData: 'footCss',
            value: 0,
            sponsorVal: "",
            exVal: "",
            areaName: "",
            sponsorValIndex: 20,
            value1: 0,
            animal: '光地',
            cityList: [],
            exAreaList: [],
            exAreaListVipFalse: [],
            sponsorDis: true,
            transferList: [],
        };
    },
    computed: {
        ...mapGetters({
            formHeaders: "getFormHeaders",
            uploadUrl: "getUploadUrl",
            exhibitionId: "getExhibitionId",
            company: "getCompany",
        }),
    },
    mounted() {
        this.initExArea()
        this.initAllHy()
    },
    methods: {
        ...mapActions({
            getAllExArea: "releaseModule/getAllExArea", //获取展区和订单
            getAllHy: "releaseModule/getAllHy", //获取展区和订单

            getCityByParentId: "exhibitionModule/getCityByParentId",
            addApplyCompany: "addApplyCompany",
            editApplyCompany: "editApplyCompany",
        }),

        async initExArea() {
            let opt = {
                clientId: "24",
                languageType: "中文"
            };
            this.exAreaList = await this.getAllExArea(opt);
            this.exAreaListVipFalse = await this.getAllExArea(opt);
            // this.exAreaListVipFalse.map((item, index) => {
            //     if (item.name == "VIP展区") {
            //         this.exAreaListVipFalse.splice(index, 1);
            //     }
            // })

        },
        // 行业
        async initAllHy() {
            let opt = {
                groupId: "11"
            };
            this.cityList = await this.getAllHy(opt);

        },


        getvalidate(prop, status, error) {
            if (status == false) {
                let opt = {
                    prop: prop,
                    status: status,
                    error: error,
                };
                this.validateList.push(opt);
            }
        },
        deteleObject(obj) {
            var uniques = [];
            var stringify = {};
            for (var i = 0; i < obj.length; i++) {
                var keys = Object.keys(obj[i]);
                keys.sort(function (a, b) {
                    return Number(a) - Number(b);
                });
                var str = "";
                for (var j = 0; j < keys.length; j++) {
                    str += JSON.stringify(keys[j]);
                    str += JSON.stringify(obj[i][keys[j]]);
                }
                if (!stringify.hasOwnProperty(str)) {
                    uniques.push(obj[i]);
                    stringify[str] = true;
                }
            }
            uniques = uniques;
            return uniques;
        },
        validForm(name) {
            // 验证表单
            return new Promise((resolve, reject) => {
                this.$refs[name].validate((valid) => {
                    console.log(valid, "valid");
                    resolve(valid);
                });
            });
        },
        handleSuccess(res, file) {
            if (res && res.list.length) {
                file.url = res.list[0];
                this.uploadList.push({
                    name: this.uploadName,
                    url: res.list[0],
                    status: "finished",
                });
            } else {
                this.uploadName = "";
            }
        },
        handleFormatError(file) {
            this.uploadName = "";
            this.$Notice.warning({
                title: "文件格式是不正确的",
                desc: "请上传jpg或者png格式的图片",
            });
        },
        handleMaxSize(file) {
            this.uploadName = "";
            this.$Notice.warning({
                title: "文件大小超过限制",
                desc: "请上传小于2M的图片",
            });
        },
        handleBeforeUpload(e) {
            this.uploadName = e.name;
            const limitNum = 1;
            const check = this.uploadList.length < limitNum;
            if (!check) {
                this.$Notice.warning({
                    title: `最多上传${limitNum}张图片`,
                });
            }
            return check;
        },
        handleRemoveByArr(file) {
            const fileList = this.uploadList;
            this.uploadList.splice(fileList.indexOf(file), 1);
        },

        handleSuccess2(res, file) {
            if (res && res.list.length) {
                file.url = res.list[0];
                this.uploadList2.push({
                    name: this.uploadName2,
                    url: res.list[0],
                    status: "finished",
                });
            } else {
                this.uploadName2 = "";
            }
        },
        handleFormatError2(file) {
            this.uploadName2 = "";
            this.$Notice.warning({
                title: "文件格式是不正确的",
                desc: "请上传jpg或者png格式的图片",
            });
        },

        handleMaxSize2(file) {
            this.uploadName2 = "";
            this.$Notice.warning({
                title: "文件大小超过限制",
                desc: "请上传小于2M的图片",

            });
        },
        handleBeforeUpload2(e) {
            this.uploadName2 = e.name;
            const limitNum = 1;
            const check = this.uploadList2.length < limitNum;
            if (!check) {
                this.$Notice.warning({
                    title: `最多上传${limitNum}张图片`,
                });
            }
            return check;
        },
        handleRemoveByArr2(file) {
            const fileList = this.uploadList2;
            this.uploadList2.splice(fileList.indexOf(file), 1);
        },

        // 选择赞助类型
        sponsorChange(e, index) {
            // if(e.tname=='首席'){
            //     return
            // }

            this.sponsorVal = e.tname
            this.sponsorValIndex = index

            // let arrIndex = this.sponsorValIndex.indexOf(index);
            //     // console.log(arrIndex);

            //     if(arrIndex>-1){
            //         this.sponsorValIndex.splice(arrIndex,1);
            //     }else{
            //         this.sponsorValIndex.push(index);
            //     }


            this.transferList = []
            let order = {}
            this.exAreaList.map(i => {
                if (i.name == 'VIP展位') {
                    this.exVal = i.id
                    i.pjNames.map(j => {
                        if (j.pjName.indexOf(e.tname) != -1) {
                            // if (j.pjName == e.tname) {
                            order.hallCount = 1 //展位数量
                            order.pType = j.pType //币种
                            order.showArea = j.standstall	//预定面积
                            order.allMoney = j.price	//总价
                            order.applyBoothOrder = {
                                boothType: j.boothType,
                                unit: j.cunit,
                                dePjNameGroupId: i.id,
                                gpName: j.gpName,
                                groupId: j.groupId,
                                dePjNameGroupName: i.name,
                                pjCode: j.pjCode,
                                pjFormat: j.pjFormat,
                                unitPrice: j.price,
                                monetaryUnit: j.pType,
                                name: j.pjName,
                                area: j.standstall,
                            }
                            // }
                        }
                    })
                }
            })

            this.transferList.push(order)

        },
        areaInputChange(e) {
            if (this.exVal) {
                this.transferList[0].showArea = e
                this.transferList[0].hallCount = e
                this.transferList[0].applyBoothOrder.area = e
            } else {
                this.value1 = e
            }

        },
        exValSelect(e) {
            this.sponsorDis = false
            this.transferList = []
            let order = {}

            this.exAreaList.map(i => {
                if (i.id == e) {
                    i.pjNames.map(j => {
                        if (j.boothType == this.animal) {
                            this.value1 = j.standstall
                            order.hallCount = 1 //展位数量
                            order.pType = j.pType //币种
                            order.showArea = this.value1	//预定面积
                            order.allMoney = j.price	//总价
                            order.applyBoothOrder = {
                                boothType: j.boothType,
                                unit: j.cunit,
                                dePjNameGroupId: i.id,
                                gpName: j.gpName,
                                groupId: j.groupId,
                                dePjNameGroupName: i.name,
                                pjCode: j.pjCode,
                                pjFormat: j.pjFormat,
                                unitPrice: j.price,
                                monetaryUnit: j.pType,
                                name: j.pjName,
                                area: this.value1
                            }

                        }
                    })
                }
            })
            this.transferList.push(order)

        },

        //校验邮箱格式
        checkEmail(email) {
            return RegExp(/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/).test(email)
        },

        async handleSubmit(name) {


            console.log('form', this.formInline);
            let form = this.formInline;
            let valid = await this.validForm('formInline');
            let errTxt = '';
            if (!valid) {
                errTxt = this.validateList[0] ? this.validateList[0].error : '请完善表单'
            }




            // 营业执照
            // let imgBusinessLicense = "";
            // let imgBusinessLicense2 = "";
            // if (this.uploadList && this.uploadList.length) {
            //     imgBusinessLicense = this.uploadList[0];
            // } else {
            //     errTxt = "请上传营业执照";
            //     valid = false;

            // }
            // if (errTxt) {
            //     this.$Message.error(errTxt);
            //     this.validateList = []
            //     return
            // }
            // if (this.uploadList2 && this.uploadList2.length) {
            //     imgBusinessLicense2 = this.uploadList2[0];
            // } else {
            //     errTxt = "请上传公司logo";
            //     valid = false;
            // }
            if (errTxt) {
                this.$Message.error(errTxt);
                this.validateList = []
                return
            }

            if (this.formInline.linkEmail) {
                if (!this.checkEmail(this.formInline.linkEmail)) {
                    this.$Message.error('请填写正确的邮箱');
                    return
                }
            }

            //   展位预定信息
            if (!this.single) {
                this.$Message.error('请选择展位预定信息');
                return
            } else {
                if (this.single == '已选择1') {
                    if (!this.sponsorVal) {
                        this.$Message.error('请选择合作类型');
                        return
                    }
                }
                if (this.single == '已选择2') {
                    if (!this.exVal) {
                        this.$Message.error('请选择展区');
                        return
                    }
                    if (!this.exVal) {
                        this.$Message.error('请选择展区');
                        return
                    }
                    if (!this.animal) {
                        this.$Message.error('请选择光地/标展');
                        return
                    }
                }
            }
            console.log('form', this.formInline);

            let formValue = {
                companyName: form.companyName, // 公司名称
                companyNameShort: form.companyNameShort, // 公司简称
                companyNameEn: form.companyNameEn,// 公司英文名称
                address: form.address, // 详细地址 
                country: form.addresss.country,
                province: form.addresss.province,
                city: form.addresss.city,
                county: form.addresss.county,

                // 展会联系人
                linkMan: form.linkMan,
                linkTitle: form.linkTitle,
                linkTelephone: form.linkMob, // 电话号码
                linkEmail: form.linkEmail,

                typeBusiness: form.industry,
                productName: form.highlightProducts,

                supportType: this.sponsorVal,//赞助类型


                imgBusinessLicense: '',
                imgLogo: '',
                // imgBusinessLicense: JSON.stringify(imgBusinessLicense),
                // imgLogo: JSON.stringify( imgBusinessLicense2 ),

            }
            return new Promise((resolve, reject) => {
                resolve({ valid: valid, form: formValue, lists: this.transferList, })
            });
        },
        validAddresss() {
            this.$refs['formInline'].validateField('addresss', (valid) => {
                console.log("addresss", valid);
            });
        },
        MalingAdresssAddresss() {
            this.$refs['formInline'].validateField('invoiceMalingAdresss', (valid) => {
                console.log("addresss", valid);
            });
        },

        // 选择战区
        sponsorSelect1() {
            this.single = '已选择1'
            this.animal = ''
            this.value1 = 0
            this.sponsorDis = true
        },
        sponsorSelect2() {
            this.single = '已选择2'
            this.sponsorDis = false
            this.sponsorVal = ''
            this.sponsorValIndex = 20
        },

    },
};
</script>

<style scoped lang='scss'>
.basic {
    /deep/ {
        .ivu-checkbox-checked .ivu-checkbox-inner {
            border-color: #00a0e9;
            background-color: #00a0e9;
        }

        .ivu-upload-select {
            display: flex;
        }

        .ivu-radio-checked .ivu-radio-inner {
            border-color: #00a0e9 !important;
        }

        .ivu-radio-inner:after {
            background-color: #00a0e9;
        }

        .ivu-switch-checked {
            border-color: #00a0e9;
            background-color: #00a0e9;
        }
    }

    &-header {
        width: 100%;
        height: 64px;
        background-color: #1e88e5;
        ;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;

        p {
            line-height: 64px;
            font-size: 20px;
        }

        span {
            width: 30px;
            height: 1px;
            background-color: #fff;
            margin: 0 15px;
        }

        .bgNone {
            background-color: transparent;
            margin: 0;
        }
    }

    &-name {
        padding: 10px 0 10px 30px;
        background-color: #fff;
    }

    &-address {
        padding: 10px 0 20px 30px;
        background-color: #fff;
    }

    &-phone {
        padding: 30px 0 10px 30px;
        background-color: #fff;
    }

    &-license {
        padding: 30px 0 10px 30px;
        background-color: #ededed;
    }

    .upload-btn {
        width: 180px;
        height: 32px;
        text-align: center;
        cursor: pointer;
        background-color: #f5f5f5;
        border: 1px dotted #bfbfbf;
    }

    .license-img {
        display: flex;
        flex-wrap: wrap;

        &-list {
            line-height: 32px;
            padding: 0 10px;
            background-color: #f5f5f5;
            display: flex;
            align-items: center;
            margin-right: 10px;
            margin-bottom: 10px;

            .txt1 {
                width: 200px;
                display: inline-block;
                height: 32px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                color: #515a6e !important;
            }

            span {
                color: #ff0011;
                cursor: pointer;
            }

            .line {
                width: 1px;
                height: 24px;
                background-color: #e6e6e6;
                margin: 0 6px;
            }
        }
    }

    &-export {
        padding: 30px 0 10px 30px;
        background-color: #fff;
    }

    &-scale {
        padding: 30px 0 10px 30px;
        background-color: #ededed;
    }

    &-tech {
        padding: 30px 0 10px 30px;
        background-color: #fff;
    }

    &-link {
        padding: 0 30px;
        background-color: #ededed;

        .ivu-form-item {
            margin-bottom: 0;
            line-height: 48px;

            /deep/ .ivu-form-item-label {
                font-size: 18px;
                padding: 0;
            }
        }
    }

    &-links {
        padding: 30px 0 10px 30px;
        background-color: #fff;
    }

    &-leader {
        padding: 0 30px;
        background-color: #ededed;
        position: relative;

        .ivu-form-item {
            margin-bottom: 0;
            line-height: 48px;

            /deep/ .ivu-form-item-label {
                font-size: 18px;
                padding: 0;
            }
        }

        .above {
            position: absolute;
            left: 240px;
            top: 10px;
        }
    }

    &-leaders {
        padding: 30px 0 10px 30px;
        background-color: #fff;
    }

    &-invoiceType {
        padding: 0 30px;
        background-color: #ededed;
        line-height: 48px;
        display: flex;
        justify-content: space-between;

        .ivu-checkbox-wrapper {
            margin: 0;
        }

        span {
            color: #ff0000;
            margin-left: 5px;
        }
    }

    &-invoices {
        padding: 30px 0 10px 30px;
        background-color: #fff;
    }
}

.tabs {
    // margin-bottom: 30px;

    &-top {
        // color: #666;
        // background: rgb(245,245,245);
        margin: 0 0 20px 0;
        // padding: 20px;
        // font-style: 18px;

        .tag {
            // width: 270px;
            line-height: 33px;
            text-align: center;
            margin-top: 5px;
            background-blend-mode: normal, normal;
            border-bottom: none;
            cursor: pointer;
            position: relative;
            background-color: rgba(255, 255, 255, 1);

            border: solid 1px rgba(212, 212, 212, 1);
            border-radius: 5px 5px 5px 5px;
            overflow: hidden;

            span {
                position: relative;
                z-index: 1;
            }

            &::before {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }

            &:hover,
            &.active {
                background-color: transparent;
                color: #2357CD;

                &::before {
                    // background-image: linear-gradient(-90deg, #2357CD 0%, #2357CD 100%),
                    //     linear-gradient(#f2f2f2, #f2f2f2);
                    //  border-color: #1e88e5;

                    background: rgba(35, 87, 205, 0.2);
                    border: solid 1px #1e88e5;
                    border-radius: 5px 5px 5px 5px;

                }
            }
        }
    }

    &-bottom {
        border: solid 1px #4f9edd;
        padding: 20px 20px 0;

        .item {
            cursor: pointer;
            width: 100%;
            text-align: center;
            font-size: 14px;
            line-height: 32px;
            border-radius: 5px;
            background-color: #f7f7f7;
            color: #666;
            margin-bottom: 20px;
            overflow: hidden;
            padding: 0 5px;
            text-overflow: ellipsis;
            white-space: nowrap;

            &.active {
                background-color: #4f9edd;
                color: #fff;
            }
        }
    }
}

/deep/ .ivu-tooltip-inner {
    max-width: 1200px;
}

// 已选择的样式
.selectedStyle {
    line-height: 48px;
    width: 100px;
    color: #1e88e5;
    text-align: center;
    border-bottom-left-radius: 20px;
    font-family: MicrosoftYaHei-Bold;
    font-size: 18px;
    font-weight: 900;
}

.headCss {
    border-top: solid 1px #1e88e5;
    border-left: solid 1px #1e88e5;
    border-right: solid 1px #1e88e5;
    background: #E8F3FC;
}

.footCss {
    border-bottom: solid 1px #1e88e5;
    border-left: solid 1px #1e88e5;
    border-right: solid 1px #1e88e5;
    // background-color: rgba(35, 87, 205, 0.2)
}

.borderCss {
    border: 1px solid #e5e5e5
}

.borderCssButt {
    border: 1px solid #1e88e5;
    color: #1e88e5;
}
</style>
